import { Chip, Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow } from '../hybrid'
import type { ChipTone } from '../hybrid'
import { Link } from 'react-router-dom'

export interface HomeWorkQueueItem {
  id: string
  item: string
  source: string
  owner: string
  age: string
  tone: ChipTone
  signal: string
  href?: string
}

export function HomeWorkQueueTable({ items }: { items: HomeWorkQueueItem[] }) {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderCell>Item</TableHeaderCell>
          <TableHeaderCell>Signal</TableHeaderCell>
          <TableHeaderCell>Owner</TableHeaderCell>
          <TableHeaderCell>Age</TableHeaderCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {items.length > 0 ? (
          items.map((item) => (
            <TableRow key={item.id}>
              <TableCell>
                {item.href ? (
                  <Link to={item.href} style={{ color: 'var(--ink)', fontWeight: 600 }}>
                    {item.item}
                  </Link>
                ) : (
                  <span style={{ color: 'var(--ink)', fontWeight: 600 }}>{item.item}</span>
                )}
                <br />
                <span className="aw-mono" style={{ color: 'var(--ink-3)', fontSize: 11.5 }}>
                  {item.source}
                </span>
              </TableCell>
              <TableCell>
                <Chip tone={item.tone}>{item.signal}</Chip>
              </TableCell>
              <TableCell className="aw-mono" style={{ color: 'var(--ink-3)', fontSize: 12 }}>
                {item.owner}
              </TableCell>
              <TableCell className="aw-mono" style={{ color: 'var(--ink-3)', fontSize: 12 }}>
                {item.age}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={4}>
              <div className="aw-empty-row">No open tenant-backed work items</div>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}
